import PropTypes from 'prop-types';
import React from 'react';

import RichText from 'components/RichText';
import Theme from 'styles/theme';

const BannerMessage = ({ message = null, icon = null }) => {
  if (!message) return null;
  return (
    <div className="BannerCarousel__slide-content">
      <RichText content={message} />
      {icon?.file?.url && (
        <div className="BannerCarousel__slide-icon">
          <img src={icon.file.url} alt="" className="BannerCarousel__icon-image" />
        </div>
      )}

      <style jsx global>{`
        .BannerCarousel__slide-content .RichText .Paragraph,
        .BannerCarousel__slide-content .RichText .InlineLink {
          color: ${Theme.get('colors-white')};
          margin-bottom: 0;
          font-size: ${Theme.get('font-size-smaller-px')};
          font-weight: ${Theme.get('font-weight-semi-bold')};
          line-height: ${Theme.get('line-height-tight')};
          text-align: center;
        }
      `}</style>
    </div>
  );
};

BannerMessage.propTypes = {
  message: PropTypes.shape({}),
  icon: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
};

export default BannerMessage;
